module.exports = __webpack_public_path__ + "static/media/taffiethule11.d394ada4.jpg";